__turbopack_context__.v({
  "HomePageSection": "CatalogHome-module__JVhnua__HomePageSection",
  "topPadding": "CatalogHome-module__JVhnua__topPadding",
});
